
import Vue from 'vue'
import AcessarConta from './components/acessar-conta/AcessarConta.vue'
import CriarConta from './components/criar-conta/CriarConta.vue'
import RecuperarConta from './components/recuperar-senha/RecuperarConta.vue'
import { limparStorage } from '@/core/utils/auth.util'
import { CLEAR_NOTIFICATION } from '@/store/actions/action'

export default Vue.extend({
  name: 'LoginView',
  components: {
    AcessarConta,
    CriarConta,
    RecuperarConta
  },
  data() {
    return {
      step: 1
    }
  },
  watch: {
    '$route.query.passo': {
      immediate: true,
      handler(passo) {
        if (passo) {
          this.$router.replace({}).finally(() => {
            this.step = parseInt(passo);
          })
        }
      }
    }
  },
  computed: {
    isMobile() {
      return this.$vuetify.breakpoint.mobile;
    }
  },
  created() {
    limparStorage()
    this.$store.commit(CLEAR_NOTIFICATION);
  }
})


